import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import TablePagination from '@material-ui/core/TablePagination';

import TableSortLabel from '@material-ui/core/TableSortLabel';

import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import AlertChip from '../AlertChip';
import Grid from '@material-ui/core/Grid';
import TransactionDetailTable from './TransactionDetailTable';
import { Divider } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import { debounce, throttle } from "throttle-debounce";

import config from "../../config/config";
import axios from 'axios';

import moment from 'moment';
import setting from "../../config/setting";
import { grid_spacing, styles } from '../CSS/Styles';

import CustomizedTable from "../CSSComponent/table"

let counter = 0;
function createData(PO_ID, flags, CreatedBy, Created_Date, Vendor_Name, amount) {
    counter += 1;
    return { id: counter, PO_ID, flags, CreatedBy, Created_Date, Vendor_Name, amount };
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    h6: {
        flex: '0 0 auto',
        width: '100%',
    },
});


class TransactionTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'id',
            selected: [],
            data: [
            ],
            fields: [],
            page: 0,
            rowsPerPage: 10,
            length: 0,
            serverPage: 1,
            height: 0,
            width: 0,
        };
        this.getTransactions = this.getTransactions.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        //console.log(this.props.token);  
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillMount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.type !== this.props.type)
        {
            this.getTransactions(this.state.serverPage, this.state.searchParam);
        }
    }
    componentDidMount() {
        this._isMounted = true;
        this.getTransactions(this.state.serverPage, this.state.searchParam);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // console.log("transaction data load finish");
    }
    getTransactions = (serverPage, searchParam) => {
        // console.log("test axios");
        //console.log(config.transactionPagination(serverPage));
        axios.get(config.transactionPagination(serverPage), {params: { 'type': this.props.type, 'filter': searchParam }})
            .then(res => {
                let transactions = res.data.results.items;
                let fields = res.data.results.table_def;
                let dataLength = res.data.count;
                // console.log(this.props.type)
                // console.log(dataLength)
                //  console.log(transactions)
                // console.log("in transactions")
                this.setState({ serverPage: serverPage, data: transactions, fields: fields, length: dataLength});
            });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        event.preventDefault();
        let preserverpage = this.serverPage;
        this.setState({ page: page/*, data: preserverpage == (Math.trunc(page / this.state.rowsPerPage) + 1) ? this.state.data : []*/}, ()=>{
            if(preserverpage != Math.trunc(page / this.state.rowsPerPage) + 1){
                this.getTransactions(Math.trunc(page / this.state.rowsPerPage) + 1, this.state.searchParam);
            }
            //console.log("in handle change page");
            //console.log(this.state.page);
            //console.log("start index : "+(page * this.state.rowsPerPage - (this.state.serverPage-1) * 10 * this.state.rowsPerPage)+"to end index : "+(page * this.state.rowsPerPage + this.state.rowsPerPage - (this.state.serverPage-1) * 10 * this.state.rowsPerPage))
                                            
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    //use debounce to prevent search api call to be too often
    debounceHandleSearch = debounce(500, ({name,value})=>{
        // console.log(value);
        // console.log("debounced");
        this.setState({filterParam: value});
        this.getTransactions(this.state.serverPage, value);
    });

    handleSearch = event => {
        const {name, value} = event.target;
        // console.log("in search");
        // console.log(e);
        // console.log(e.target);
        this.debounceHandleSearch({name,value});
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    getFlagName(id){
    	switch (id){
    		case 1:
    			return "Missing Document";
    		case 2:
    		case 3:
    			return "Duplicate Entry";
    		case 4:
    		case 5:
    			return "Missing Amount";
    		default:
    			return "Amount Greater Than 30k";
    	}

    }

    render() {
        const { classes } = this.props;
        const { data, order, orderBy, selected, rowsPerPage, page, fields,length} = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - (page * rowsPerPage - this.state.serverPage * 10 * rowsPerPage));
        // console.log('transaction table')
        // console.log(fields)

        const content_height = this.state.height - 145 + "px";
        const tbody_height = this.state.height - 260 + "px";
        // console.log(content_height);

        console.log(data)

        return (
            <div className={classes.root} style={{height: content_height}}>
                <div className={classes.tableWrapper} style={{height: tbody_height}}>
                    <Grid container>
                        <Grid item md={12}>
                            <CustomizedTable
                                tableHeader={fields}
                                data={data}
                                searchBar={true}
                            />
                        </Grid>
                    </Grid>
                </div>
                <TablePagination
                    component="div"
                    count={length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    // rowsPerPageOptions={10}
                    // labelDisplayedRows={()=>`${page*rowsPerPage}-${(page+1)*rowsPerPage} of ${length}`}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </div>
        );
    }
}

TransactionTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TransactionTable);


// WEBPACK FOOTER //
// ./src/components/Transactions/TransactionTable.js